/* eslint-disable @typescript-eslint/naming-convention */
import React from 'react';

export const RowCountContext = React.createContext<number | null>(null);
